export class WorkOrderEditTemplateConfiguration {


  WorkOrder: { Oid: number } | any | null = null;
  visible : boolean = false;

  private constructor() {
  }

  public static create = () => new WorkOrderEditTemplateConfiguration();

  setWorkOrderOid(value: number | null) {

    this.WorkOrder = value ? {Oid: value} : null;
    return this;

  }


}
